// ABOUTME: Table component for embedding data tables in reports.
// ABOUTME: Renders tabular data with styling matching the obsidian theme.

interface TableData {
  headers: string[];
  rows: (string | number)[][];
}

interface ReportTableProps {
  data: TableData;
  title?: string;
}

export function ReportTable({ data, title }: ReportTableProps) {
  if (!data.headers || !data.rows || data.headers.length === 0) {
    return (
      <div className="text-surface-500 text-sm italic p-4 text-center border border-dashed border-surface-200 rounded-sm">
        No table data available
      </div>
    );
  }

  return (
    <div className="w-full overflow-x-auto">
      {title && (
        <h4 className="text-sm font-medium text-surface-600 mb-3">
          {title}
        </h4>
      )}
      <table className="w-full border-collapse">
        <thead>
          <tr>
            {data.headers.map((header, index) => (
              <th
                key={index}
                className="px-4 py-3 text-left text-xs font-semibold text-surface-600 uppercase tracking-wider bg-surface-50 border-b border-surface-200 first:rounded-tl-sm last:rounded-tr-sm"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.rows.map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className="border-b border-surface-200 last:border-b-0 hover:bg-surface-50 transition-colors"
            >
              {row.map((cell, cellIndex) => (
                <td
                  key={cellIndex}
                  className="px-4 py-3 text-sm text-surface-800"
                >
                  {typeof cell === 'number' ? cell.toLocaleString() : cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
